import { createActionGroup } from '@ngrx/store';

export const FichierActions = createActionGroup({
  source: 'Fichier',
  events: {}
});
